import {
  queryRouteDefinitionList,
  queryRouteDefinitionDetail,
  createRouteDefinition,
  updateRouteDefinition,
  deleteRouteDefinition,
  toggleRouteDefinitionStatus,
  queryCredentialList,
  queryCredentialDetail,
  createCredential,
  updateCredential,
  deleteCredential,
  resetCredentialSecret,
  toggleCredentialStatus,
  queryCredentialBindings,
  bindCredentialRoutes,
  unbindCredentialRoute,
  toggleBindingStatus,
} from '@/services/apiCredential';

const isSuccess = status => /20\d/.test(status);

export default {
  namespace: 'apiCredential',

  state: {
    routeDefinition: {
      list: [],
      pagination: {},
    },
    credential: {
      list: [],
      pagination: {},
    },
    binding: {
      list: [],
      pagination: {},
    },
  },

  effects: {
    // -------- Route Definitions --------
    *fetchRouteDefinitions({ payload }, { call, put }) {
      const response = yield call(queryRouteDefinitionList, payload);
      if (!isSuccess(response.status)) return;
      const { data } = response;
      yield put({
        type: 'saveRouteDefinitions',
        payload: {
          list: data.data || [],
          pagination: {
            total: data.total,
            pageSize: data.per_page,
            current: data.current_page,
          },
        },
      });
    },

    *fetchRouteDefinitionDetail({ payload }, { call }) {
      const { status, data } = yield call(queryRouteDefinitionDetail, payload);
      if (!isSuccess(status)) return null;
      return data.data || data;
    },

    *createRouteDefinition({ payload }, { call }) {
      const { status, data } = yield call(createRouteDefinition, payload);
      if (!isSuccess(status)) return false;
      return data.data || data;
    },

    *updateRouteDefinition({ payload }, { call }) {
      const { status, data } = yield call(updateRouteDefinition, payload);
      if (!isSuccess(status)) return false;
      return data.data || data;
    },

    *deleteRouteDefinition({ payload }, { call }) {
      const { status } = yield call(deleteRouteDefinition, payload);
      return isSuccess(status);
    },

    *toggleRouteDefinitionStatus({ payload }, { call }) {
      const { id, status: nextStatus } = payload;
      const { status } = yield call(
        toggleRouteDefinitionStatus,
        id,
        nextStatus
      );
      return isSuccess(status);
    },

    // -------- Credentials --------
    *fetchCredentials({ payload }, { call, put }) {
      const response = yield call(queryCredentialList, payload);
      if (!isSuccess(response.status)) return;
      const { data } = response;
      yield put({
        type: 'saveCredentials',
        payload: {
          list: data.data || [],
          pagination: {
            total: data.total,
            pageSize: data.per_page,
            current: data.current_page,
          },
        },
      });
    },

    *fetchCredentialDetail({ payload }, { call }) {
      const { status, data } = yield call(queryCredentialDetail, payload);
      if (!isSuccess(status)) return null;
      return data.data || data;
    },

    *createCredential({ payload }, { call }) {
      const { status, data } = yield call(createCredential, payload);
      if (!isSuccess(status)) return false;
      return data.data || data;
    },

    *updateCredential({ payload }, { call }) {
      const { status, data } = yield call(updateCredential, payload);
      if (!isSuccess(status)) return false;
      return data.data || data;
    },

    *deleteCredential({ payload }, { call }) {
      const { status } = yield call(deleteCredential, payload);
      return isSuccess(status);
    },

    *resetSecret({ payload }, { call }) {
      const { status, data } = yield call(resetCredentialSecret, payload);
      if (!isSuccess(status)) return false;
      return data.data || data;
    },

    *toggleCredentialStatus({ payload }, { call }) {
      const { id, status: nextStatus } = payload;
      const { status } = yield call(toggleCredentialStatus, id, nextStatus);
      return isSuccess(status);
    },

    // -------- Credential-Route Bindings --------
    *fetchCredentialBindings({ payload }, { call, put }) {
      const { id, params } = payload;
      const response = yield call(queryCredentialBindings, id, params);
      if (!isSuccess(response.status)) return;
      const { data } = response;
      yield put({
        type: 'saveBindings',
        payload: {
          list: data.data || [],
          pagination: {
            total: data.total,
            pageSize: data.per_page,
            current: data.current_page,
          },
        },
      });
    },

    *bindCredentialRoutes({ payload }, { call }) {
      const { id, routeIds } = payload;
      const { status, data } = yield call(bindCredentialRoutes, id, routeIds);
      if (!isSuccess(status)) return false;
      return data.data || data;
    },

    *unbindCredentialRoute({ payload }, { call }) {
      const { credentialId, routeId } = payload;
      const { status } = yield call(
        unbindCredentialRoute,
        credentialId,
        routeId
      );
      return isSuccess(status);
    },

    *toggleBindingStatus({ payload }, { call }) {
      const { credentialId, routeId, status: nextStatus } = payload;
      const { status } = yield call(
        toggleBindingStatus,
        credentialId,
        routeId,
        nextStatus
      );
      return isSuccess(status);
    },
  },

  reducers: {
    saveRouteDefinitions(state, action) {
      return {
        ...state,
        routeDefinition: action.payload,
      };
    },
    saveCredentials(state, action) {
      return {
        ...state,
        credential: action.payload,
      };
    },
    saveBindings(state, action) {
      return {
        ...state,
        binding: action.payload,
      };
    },
  },
};
